import React, { useState, useEffect } from "react";
import {
  Input,
  Select,
  Col,
  Row,
  Form,
  notification,
  Button,
  Empty,
  Upload,
  Spin,
} from "antd";
import RequestHandler from "util/RequestHandler";
import {
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import Replace2x from "../../util/Extensions/ReplaceExtension";
import "react-phone-input-2/lib/style.css";
import config from "../../util/ApiforContext";
const { Option } = Select;
const token = localStorage.getItem("token");
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};

const InvoiceSubscriptionAdd = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [productTypes, setProductTypes] = useState({
    data: [],
    loading: true,
  });
  const [products, setProducts] = useState({
    data: [],
    loading: false,
  });
  const [spinLoading, SetSpinLoading] = useState(false);
  const errorList = [];
  const errorListNotification = (type) => {
    errorList.map((item) => {
      notification[type]({
        message: "Hata",
        description: item,
        duration: 2,
      });
    });
  };

  useEffect(() => {
    RequestHandler.get(`/Invoice/GetProductTypes`, false, {
      rawResponse: true,
    }).then((response) => {
      if (response.status == 200) {
        setProductTypes({
          data: response.data,
          loading: false,
        });
      }
    });
  }, []);

  const getProducts = (value) => {
    setProducts({
      ...products,
      loading: true,
    });
    const filtervalue = "'" + value + "'";
    RequestHandler.post(
      `/Invoice/GetProducts?$filter=productTypeId eq  ${filtervalue}&$orderby=name`,
      {},
      false
    ).then((response) => {
      if (response.value != Empty) {
        setProducts({
          data: response,
          loading: false,
        });
      } else {
        setProducts({
          data: [],
        });
      }
    });
  };

  const handleSelectedProductTypes = (value) => {
    form.resetFields(["product"]);
    getProducts(value);
  };

  const onFinishFailed = () => {
    setLoading(false);
  };

  const onFinish = (values) => {
    const productTypeName = productTypes.data.find(
      (x) => x.id == values.productType
    ).name;

    const productName = products.data.find((x) => x.id == values.product).name;
    RequestHandler.post(
      "/InvoiceSubscription",
      {
        name: values.name,
        product: productName,
        productType: productTypeName,
        subscriberNo: values.subscriberNo,
      },
      true
    ).then((response) => {
      if (response.success) {
        setLoading(false);
        onSuccess();
      } else {
        setLoading(false);
      }
    });
  };

  const propsFirmExcel = {
    name: "excel",
    action: `${config.apiUrl}/InvoiceSubscription/ImportExcel?type=1`,
    headers: {
      Authorization:
        "bearer " + token?.replace('"', "").replace('"', "").toString(),
    },
    onChange(info) {
      const { response, status } = info.file;
      if (info.fileList.length > 0) {
        SetSpinLoading(true);
      }
      if (info.file.status === "done") {
        excelDownload("success");
        setTimeout(
          function () {
            window.location.reload();
          }.bind(this),
          2000
        );
      } else if (info.file.status === "error") {
        if (info.file.response.statusCode === 406) {
          info.file.response.data.map((item) => {
            errorList.push(item);
            setTimeout(function () {
              window.location.reload();
            }, 5000);
          });
          errorListNotification("error");
          excelDownloadFailedUntilThis("error");
          setTimeout(function () {
            window.location.reload();
          }, 5000);
        } else {
          const notificationType = response.success ? "success" : "error";

          notification[notificationType]({
            message: response.message,
            duration: 3,
          });
          if (!response.success) {
            downloadImportResult(info.file.response.data);
          }
          setTimeout(function () {
            window.location.reload();
          }, 5000);
        }

        SetSpinLoading(false);
      }
    },
  };

  const downloadImportResult = (fileName) => {
    window.open(
      `${config.apiUrl}/InvoiceSubscription/DownloadImportResult?t=${Replace2x(
        token
      )}&fileName=${fileName}`
    );
  };

  const excelDownload = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Excel şablonu indirme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const excelDownloadFailedUntilThis = (type) => {
    notification[type]({
      message: "HATA",
      description: "Bu veriden sonra yüklemeye devam edilemedi.",
      duration: 5,
    });
  };

  const downloadExcel = () => {
    window.open(
      `${config.apiUrl}/InvoiceSubscription/DownloadExcel?t=${Replace2x(token)}`
    );
  };

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  return (
    <div>
      <>
        <Spin tip="Excel yükleniyor..." spinning={spinLoading}>
          <Form
            {...formItemLayout}
            name="invoiceSubscriptionAdd"
            initialValues={{
              remember: true,
            }}
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row>
              <Col span={2}></Col>
              <Col span={20}>
                <Form.Item
                  label="Kurum Tipi :"
                  name="productType"
                  style={{ marginTop: "4%" }}
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Kurum Tipi alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Select
                    name="productTypes"
                    style={{ width: "100%", marginBottom: "3%" }}
                    loading={false}
                    onChange={handleSelectedProductTypes}
                  >
                    {productTypes.data.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Kurum :"
                  name="product"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Kurum alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Select
                    autoClearSearchValue
                    showSearch
                    optionFilterProp="children"
                    name="products"
                    style={{ width: "100%" }}
                    loading={products.loading}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {products.data.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Abone No"
                  name="subscriberNo"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Abone no alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    autoComplete="off"
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item label="Ad :" name="name">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={2}></Col>
              <Col span={8}>
                <Upload {...propsFirmExcel}>
                  <Button icon={<UploadOutlined />}>
                    Excel ile Abonelik Ekle
                  </Button>
                </Upload>
              </Col>
              <Col span={4}>
                <Button
                  icon={<DownloadOutlined />}
                  onClick={(() => setLoading(true), downloadExcel)}
                  loading={loading}
                >
                  Excel Şablonu İndir
                </Button>
              </Col>
              <Col span={6}></Col>
              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </>
    </div>
  );
};
export default InvoiceSubscriptionAdd;
